import translate from "../../../common/Dictionary";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const StepOne = ({ state, userData, updateServiceCat, updateServiceSubCat, updateService, onNext }) => {
    return (
        <div className="axa-project-card">
            <div className="axa-subcat-card-padding axa-card-shadow mt-4 bg-white">
                <div className="axa-mobile-hidden" style={{ "height": "32px" }}></div>
                <div className="axa-service-card-title align-left pt-5">{translate("newProjectTitleService", userData.language)}</div>
                <div className="title-sub-text align-left pt-4 pb-4">{translate("newProjectTextService", userData.language)}</div>
                <hr className="axa-service-card-diveder" />
                <div className="title-sub-text align-left pt-4">
                    <label htmlFor="select-service-category">{translate("newProjectLabelCategory", userData.language)}</label>
                </div>
                <div className="title-sub-text align-left pt-1">
                    <div className="row">
                        <div className="col-md-8 col-sm-12">
                            <select
                                id="select-service-category"
                                value={state.selectedCatId}
                                className="form-select text-primary"
                                onChange={(event) => updateServiceCat(event.target.value)}
                            >
                                <option className="text-black" value={0} style={{ display: (state.selectedCatId === 0 ? "" : "none") }}>{translate("newProjectSelectMakeASelectionText", userData.language)}</option>
                                {state.serviceCategories?.map((cat, index) => {
                                    return (
                                        <option
                                            key={"catOption-" + index}
                                            className="text-black"
                                            value={cat.id}
                                        >
                                            {translate(cat.code, userData.language)}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </div>
                </div>
                <div style={{ display: state.selectedCatId !== 0 ? "" : "none" }}>
                    <div className="title-sub-text align-left pt-3">
                        <label htmlFor="select-service-subcategory">{translate("newProjectLabelSubCategory", userData.language)}</label>
                    </div>
                    <div className="title-sub-text align-left pt-1">
                        <div className="row">
                            <div className="col-md-8 col-sm-12">
                                <select
                                    id="select-service-subcategory"
                                    value={state.selectedSubcatId}
                                    className="form-select text-primary"
                                    onChange={(event) => updateServiceSubCat(event.target.value)}
                                >
                                    <option className="text-black" value={0} style={{ display: (state.selectedSubcatId === 0 ? "" : "none") }}>{translate("newProjectSelectMakeASelectionText", userData.language)}</option>
                                    {state.serviceCategories?.find(x => x.id === parseInt(state.selectedCatId))?.serviceSubCategories?.map((cat, index) => {
                                        return (
                                            <option
                                                key={"catOption-" + index}
                                                className="text-black"
                                                value={cat.id}
                                            >
                                                {translate(cat.code, userData.language)}
                                            </option>)
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ display: state.selectedSubcatId !== 0 ? "" : "none" }}>
                    <div className="title-sub-text align-left pt-3">{translate("newProjectLabelService", userData.language)}</div>
                    <div className="axa-under-text align-left">{translate("newProjectLabelServiceUnderText", userData.language)}</div>
                    <div className="title-sub-text align-left pt-1">
                        <div className="row">
                            {state.serviceCategories?.find(x => x.id === parseInt(state.selectedCatId))?.serviceSubCategories?.find(x => x.id === parseInt(state.selectedSubcatId))?.services.map((service, index) => {
                                return (
                                    <div
                                        key={"serviceRadio-" + index}
                                        className="col-md-4 col-12 d-grid mt-2 axa-service-selection-button-height"
                                    >
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="optionsService"
                                            id={"option-" + index}
                                            value={service.id}
                                            checked={service.id === parseInt(state.selectedServiceId)}
                                            onChange={(event) => updateService(event.target.value)}
                                        />
                                        <label className="btn btn-outline-primary axa-service-radio-label" htmlFor={"option-" + index}>
                                            {translate(service.code, userData.language)}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex flex-column-reverse flex-md-row justify-content-end pt-5">
                <button
                    className="btn btn-secondary"
                    disabled={parseInt(state.selectedServiceId) === 0}
                    onClick={onNext}
                >
                    {translate("btnProjectForward", userData.language)}
                    <FontAwesomeIcon className="ms-1" icon={faArrowRight} />
                </button>
            </div>
        </div>
    );
};

export default StepOne;
